import React, { useEffect, useRef, useState } from "react";
import { useIntersectionObserver } from "react-intersection-observer-hook";

const InView = ({ children, ckey }) => {
  // `useTrackVisibility` also returns a tuple like `useIntersectionObserver`.
  // First item is the same `ref` callback to set the node to observe.
  // Second item is an object that we can use to decide if a node is visible.
  // `entry`: Same object which is returned by `useIntersectionObserver`.
  // `rootRef`: Same ref callback which is returned by `useIntersectionObserver`.
  // `isVisible`: Becomes true/false based on the response of `IntersectionObserver`.
  // `wasEverVisible`: When our observed node becomes visible once, this flag becomes `true` and stays like that.
  const [ref, { entry, _rootRef }] = useIntersectionObserver({
    //  rootMargin: "100px 0px 50px 0px",
    threshold: 0.01,
  });
  const isVisible = entry && entry.isIntersecting;
  const previousCkey = useRef();

  const [keepInView, setKeepInView] = useState(false);

  useEffect(() => {
    console.log(
      "inview previousCkey",
      previousCkey,
      ckey,
      isVisible ? "visible" : "not visible"
    );

    if (!ckey && isVisible) {
      setKeepInView(true);
    } else if (previousCkey.current != ckey) {
      console.log("inview set previousckey", ckey);
      previousCkey.current = ckey;
      setKeepInView(isVisible);
    } else if (isVisible && !keepInView) {
      setKeepInView(true);
    }
  }, [isVisible, ckey]);

  return (
    <div ckey={ckey} ref={ref}>
      {keepInView && children}
    </div>
  );
};

// InView.whyDidYouRender = true;

export default InView;
